import { Pipe, PipeTransform } from '@angular/core';

export enum UrlTarget {
  BLANK = '_blank',
  PARENT = '_parent',
  SELF = '_self',
}

/**
 * Safely checks if boolean target is _blank or _self
 * Returns _parent if value is undefined, null or not 'true'.
 * Returns _blank if value is true or 'true'.
 */
@Pipe({
  name: 'urlTarget',
  standalone: true,
})
export class UrlTargetPipe implements PipeTransform {
  transform(targetBool: string | boolean | undefined | null): string {
    if (targetBool === undefined || targetBool === null) {
      return UrlTarget.SELF;
    }
    return String(targetBool) === 'true' ? UrlTarget.BLANK : UrlTarget.SELF;
  }
}
